import React from 'react'

function ViewProductReturns() {
  return (
    <div>ViewProductReturns</div>
  )
}

export default ViewProductReturns